module.exports = {
	"id": "SZ",
	"name": "Swaziland",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.001099,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.002198,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.02198,
			"19": null,
			"20": 0.002198,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.004396,
			"26": 0.007693,
			"27": null,
			"28": null,
			"29": 0.002198,
			"30": 0.001099,
			"31": 0.006594,
			"32": 0.012089,
			"33": 0.008792,
			"34": null,
			"35": 0.006594,
			"36": 0.008792,
			"37": 0.004396,
			"38": 0.003297,
			"39": 0.006594,
			"40": 0.016485,
			"41": 0.001099,
			"42": 0.001099,
			"43": 0.029673,
			"44": 0.002198,
			"45": 0.012089,
			"46": 0.028574,
			"47": 0.01099,
			"48": 0.004396,
			"49": 0.151662,
			"50": 0.028574,
			"51": 0.074732,
			"52": 0.050554,
			"53": 3.211278,
			"54": 0.62643,
			"55": 0.012089,
			"56": 0.002198,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.049455,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.001099,
			"9": null,
			"10": 0.006594,
			"11": 0.002198,
			"12": 0.001099,
			"13": 0.002198,
			"14": 0.001099,
			"15": 0.002198,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.002198,
			"20": null,
			"21": 0.015386,
			"22": 0.009891,
			"23": null,
			"24": 0.004396,
			"25": 0.001099,
			"26": 0.009891,
			"27": 0.002198,
			"28": 0.003297,
			"29": null,
			"30": null,
			"31": 0.068138,
			"32": 0.004396,
			"33": null,
			"34": null,
			"35": 0.003297,
			"36": 0.009891,
			"37": 0.006594,
			"38": 0.085722,
			"39": 0.002198,
			"40": 0.016485,
			"41": 0.005495,
			"42": 0.003297,
			"43": 0.08792,
			"44": 0.040663,
			"45": 0.217602,
			"46": 0.027475,
			"47": 0.178038,
			"48": 0.12089,
			"49": 1.145158,
			"50": 0.090118,
			"51": 0.005495,
			"52": null,
			"3.5": 0.001099,
			"3.6": 0.001099
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": 0.004396,
			"16": null,
			"17": null,
			"18": 0.005495,
			"19": null,
			"20": 0.004396,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.018683,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.029673,
			"34": null,
			"35": 0.003297,
			"36": 0.006594,
			"37": 0.038465,
			"38": 0.008792,
			"39": 0.007693,
			"40": 0.312116,
			"41": 0.037366,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.009891,
			"12.1": 0.026376
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": 0.018683,
			"7": null,
			"8": 0.007693,
			"9": 0.027475,
			"10": 0.092316,
			"3.1": null,
			"3.2": null,
			"5.1": 0.019782,
			"6.1": 0.001099,
			"7.1": 0.001099,
			"9.1": 0.038465
		},
		"ios_saf": {
			"8": 0,
			"10": 0.212964392173,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.00573914394255,
			"8.1-8.4": 0.0106028252498,
			"9.0-9.2": 0.00505822855953,
			"9.3": 0.0771704100749
		},
		"android": {
			"3": 0,
			"4": 0.015617,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.001952125,
			"4.1": 0.05633275,
			"4.2-4.3": 0.140831875,
			"4.4": 0.32293725,
			"4.4.3-4.4.4": 0.325726
		},
		"ie": {
			"6": 0.0088552250423,
			"7": 0.0487037377327,
			"8": 0.463792411591,
			"9": 0.234663463621,
			"10": 0.184852822758,
			"11": 1.67585133926,
			"5.5": null
		},
		"op_mob": {
			"0": 5.7430543429,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.159529287303
		},
		"edge": {
			"12": 0.103306,
			"13": 0.254968,
			"14": 0.093415
		},
		"ie_mob": {
			"10": 0.110572985915,
			"11": 0.450190014085
		},
		"bb": {
			"7": 0.026703,
			"10": null
		},
		"samsung": {
			"0": 0.409446
		},
		"and_uc": {
			"0": 1.415259
		},
		"op_mini": {
			"0": 77.3751723698
		},
		"and_chr": {
			"0": 2.310345
		},
		"and_ff": {
			"0": 0.035604
		}
	},
	"total": 99.598556
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/SZ.json
 ** module id = 654
 ** module chunks = 0
 **/